import moment from 'moment';
import React from 'react';
import { getHoursToCancel, getIsPenalizationFeatureOn } from '../config';

const ConfirmCancelModal = ({ show, session, onConfirm, onClose }) => {

  if (!show || !session) return null;
  
  const isPenalizationFeatureOn = getIsPenalizationFeatureOn();
  const hoursToCancel = getHoursToCancel();
  const cancelLimit = moment.utc(session.start_date).local().subtract(hoursToCancel, 'hour');

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Confirmación de cancelación</h5>
            <button type="button" className="close" onClick={onClose}>
              <span>&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <p> Al cancelar despues del: <span className="font-weight-bold">{cancelLimit.format('dddd D [de] MMMM [a las] HH:mm')}</span> puede descontarse la clase { isPenalizationFeatureOn ? 'y/o tener penalización' : '' }</p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-danger" onClick={onClose}>
              Cancelar
            </button>
            <button type="button" className="btn btn-success" onClick={() => onConfirm(session.id)}>
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmCancelModal;
